import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { alpha, Box, InputBase } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  searchWrap: {
    padding: "10px 20px",
    [theme.breakpoints.down("sm")]: {
      padding: 10,
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.grey, 0.35),
    marginRight: 0,
    marginLeft: 0,
    width: "100%",
  },
  searchIcon: {
    width: theme.spacing(4),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    right: 0,
  },
  inputRoot: {
    width: "100%",
  },
  inputInput: {
    paddingTop: 11,
    paddingRight: 20,
    paddingBottom: 11,
    paddingLeft: 11,
    transition: theme.transitions.create("width"),
    fontSize: 12,
  },
  zoomIcon: {
    fontSize: 16,
  },
}));

const WorkspaceSelectorSearchBox = ({ onChange }) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Box className={classes.searchWrap}>
      <Box className={classes.search}>
        <InputBase
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          inputProps={{ "aria-label": "Search" }}
          onChange={e => onChange?.(e.target.value)}
          placeholder={intl.formatMessage({ id: "nav.search" })}
        />
        <Box className={classes.searchIcon}>
          <i className={`nc-icon nc-zoom-split ${classes.zoomIcon}`} />
        </Box>
      </Box>
    </Box>
  );
};

WorkspaceSelectorSearchBox.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default WorkspaceSelectorSearchBox;
